import { render, staticRenderFns } from "./HomeBio.vue?vue&type=template&id=67ef72ff&"
import script from "./HomeBio.vue?vue&type=script&lang=js&"
export * from "./HomeBio.vue?vue&type=script&lang=js&"
import style0 from "./HomeBio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports